// import CardGiftcardIcon from '@mui/icons-material/CardGiftcard';
import React from 'react';
// import AddCart from '../pages/external/static/AddCart';
// const CategoryList = React.lazy(() => import('../pages/external/Service For you/CategoryList'));
// const ServiceFYUPRegistList = React.lazy(() => import('../pages/external/Service For you/ServiceFYUPRegistList'));
// const ServiceForYouUPReg = React.lazy(() => import('../pages/external/Service For you/ServiceForYouUPReg'));
const VolunteerApEventAprovalList = React.lazy(() => import('../pages/external/volunteer/VolunteerApEventAprovalList'));
const VolunteerApEventRegList = React.lazy(() => import('../pages/external/volunteer/VolunteerApEventRegList'));
const VolunteerApEventRegister = React.lazy(() => import('../pages/external/volunteer/VolunteerApEventRegister'));

const VolunteerApEventView = React.lazy(() => import('../pages/external/volunteer/VolunteerApEventView'));
// const VolunteerEventSelection = React.lazy(() => import('../pages/external/volunteer/VolunteerEventSelection'));
const VolunteerUpEventSeleList = React.lazy(() => import('../pages/external/volunteer/VolunteerUpEventSeleList'));
// const AddGiftService = React.lazy(() => import('../pages/internal/Service for Gift/AddGiftService'));
// const GiftPayment = React.lazy(() => import('../pages/internal/Service for Gift/GiftPayment'));
// const GiftServiceList = React.lazy(() => import('../pages/internal/Service for Gift/GiftServiceList'));
// const Points = React.lazy(() => import('../pages/external/Service For you/Points'));
const VolunteerDetail = React.lazy(() => import('../pages/external/volunteer/VolunteerDetail'));
const VolunteerList = React.lazy(() => import('../pages/external/volunteer/VolunteerList'));
// const VolunteerRegistration = React.lazy(() => import('../pages/external/volunteer/VolunteerRegistrationForm'));
export const navLinksData = [
  {
    name: 'Volunteer',
    children: [
      // {
      //   name: 'registration',
      //   link: '/VolunteerRegistration',
      //   ishidden: true, // hide from main menu
      //   isAdmin: false, // will be visible to general user only
      //   element: <VolunteerRegistration />
      // },
      {
        name: 'Volunteer List',
        link: '/volunteerlist',
        ishidden: false,
        isAdmin: false,
        element: <VolunteerList />,
      },

      {
        name: 'UpdateVolunteerForm',
        link: `/volunteer-detail/:id`,
        ishidden: true,
        element: <VolunteerDetail />,
      },
      {
        name: 'Volunteer Event Register',
        link: '/VolunteerApEventRegister',
        ishidden: true,
        isAdmin: true,
        element: <VolunteerApEventRegister />,
      },
      {
        name: 'Volunteer Event Registration List',
        link: '/VolunteerApEventRegList',
        ishidden: false,
        isAdmin: true,
        element: <VolunteerApEventRegList />,
      },
      // {
      //   name: 'Volunteer-Event-Selection',
      //   link: '/VolunteerEventSelection',
      //   ishidden: true,
      //   isAdmin: false,
      //   element: <VolunteerEventSelection />
      // },
      {
        name: 'Volunteer Event Selection List',
        link: '/VolunteerUpEventSeleList',
        ishidden: false,
        isAdmin: false,
        element: <VolunteerUpEventSeleList />,
      },
      {
        name: 'Volunteer Event View',
        link: '/VolunteerApEventView/:id',
        ishidden: true,
        element: <VolunteerApEventView />,
      },
      {
        name: 'Volunteer Event Approval List',
        link: '/VolunteerApEventAprovalList',
        ishidden: false,
        isAdmin: true,
        element: <VolunteerApEventAprovalList />,
      },
    ],
  },
];
